module.exports = __webpack_public_path__ + "static/00009.e4973e79.jpg";